/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_error_unknown_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown error`)
};

const zh_hans1_settings_error_unknown_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知错误`)
};

const zh_hant1_settings_error_unknown_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知錯誤`)
};

const fr_settings_error_unknown_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur inconnue`)
};

const de_settings_error_unknown_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannter Fehler`)
};

const ja_settings_error_unknown_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不明なエラー`)
};

const ko_settings_error_unknown_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알 수 없는 오류`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_error_unknown_error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_error_unknown_error(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_error_unknown_error", locale)
	if (locale === "en") return en_settings_error_unknown_error(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_error_unknown_error(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_error_unknown_error(inputs)
	if (locale === "fr") return fr_settings_error_unknown_error(inputs)
	if (locale === "de") return de_settings_error_unknown_error(inputs)
	if (locale === "ja") return ja_settings_error_unknown_error(inputs)
	return ko_settings_error_unknown_error(inputs)
};